(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-guide"] && !Shopify.designMode) return;
  try {
    
  (function ($) {
    const generateGuideNavi = () => {
      const guideArr = $.getElementsByClassName('c-guide');
      const $guideNavi = $.createElement('div');
      $guideNavi.classList.add('c-guide-navi');

      const createNewElem = (selector, className = '') => {
        let $newElem = $.createElement(selector);
        if (className) $newElem.classList.add(className);
        return $newElem;
      };

      /**
       * 見出しタグへのID付与とc-guide-naviの生成
       */
      const init = () => {
        [...guideArr].map((el, i) => {
          let h1Arr = el.getElementsByClassName('c-guide__heading1');
          let h2Arr = el.getElementsByClassName('c-guide__heading2');

          let $guideNaviTitle = createNewElem('div', 'c-guide-navi__title');
          let $guideNaviItems = createNewElem('ul', 'c-guide-navi__items');

          [...h1Arr].map((h1, j) => {
            h1.setAttribute('id', `heading1-${i}-${j}`);

            let iconSrc = h1.dataset.iconSrc;

            let $anchor = createNewElem('a');
            $anchor.setAttribute('href', `#heading1-${i}-${j}`);
            $anchor.textContent = h1.textContent;
            $guideNaviTitle.setAttribute('style', `--icon-src: url(${iconSrc});`);
            $guideNaviTitle.appendChild($anchor);
          });
          [...h2Arr].map((h2, j) => {
            h2.setAttribute('id', `heading2-${i}-${j}`);

            let $guideNaviItem = createNewElem('li', 'c-guide-navi__item');
            let $anchor = createNewElem('a');
            $anchor.setAttribute('href', `#heading2-${i}-${j}`);
            $anchor.textContent = h2.textContent;
            $guideNaviItem.appendChild($anchor);
            $guideNaviItems.appendChild($guideNaviItem);
          });

          $guideNavi.appendChild($guideNaviTitle);
          $guideNavi.appendChild($guideNaviItems);
        });
      };

      const appendNavi = () => {
        const $sidebar = $.getElementById('GuideNavi');
        $sidebar.appendChild($guideNavi);
      };

      init();
      appendNavi();
    };
    generateGuideNavi();
  })(document);


  } catch(e) { console.error(e); }
})();
})();
